/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { FileInfoRes } from '../models/file-info-res';

@Injectable({ providedIn: 'root' })
export class FileApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiFilePost()` */
  static readonly ApiFilePostPath = '/api/file';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFilePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFilePost$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<FileInfoRes>> {
    const rb = new RequestBuilder(this.rootUrl, FileApiService.ApiFilePostPath, 'post');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FileInfoRes>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiFilePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFilePost(
    params?: {
    },
    context?: HttpContext
  ): Observable<FileInfoRes> {
    return this.apiFilePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<FileInfoRes>): FileInfoRes => r.body)
    );
  }

}
